// T006 + T041 — Wallet admin API client (paymentApi-backed).
import { paymentApi } from "../../config/apiConfig";
import type {
  AdminGetWalletQuery,
  AdminGetWalletResponse,
  AdminIssueRequest,
  AdminRevokeRequest,
  AdminRevokeResponse,
  IssueCreditResponse,
  WalletListQuery,
  WalletListResponse,
} from "../../types/wallet";

// Also the history pager: the cursor is scoped to `accountId`, so passing the
// previous `next_cursor` returns the next page of the same wallet.
export const adminGetWallet = async (
  accountId: string,
  query: AdminGetWalletQuery = {},
): Promise<AdminGetWalletResponse> => {
  const params = new URLSearchParams();
  if (query.limit) params.set("limit", String(query.limit));
  if (query.cursor) params.set("cursor", query.cursor);
  const qs = params.toString();
  const path = `admin/wallets/${encodeURIComponent(accountId)}`;
  const response = await paymentApi.get<AdminGetWalletResponse>(
    qs ? `${path}?${qs}` : path,
  );
  return response.data;
};

export const adminIssueCredit = async (
  accountId: string,
  request: AdminIssueRequest,
): Promise<IssueCreditResponse> => {
  const response = await paymentApi.post<IssueCreditResponse>(
    `admin/wallets/${encodeURIComponent(accountId)}/issue`,
    request,
  );
  return response.data;
};

export const adminRevokeCredit = async (
  accountId: string,
  request: AdminRevokeRequest,
): Promise<AdminRevokeResponse> => {
  const response = await paymentApi.post<AdminRevokeResponse>(
    `admin/wallets/${encodeURIComponent(accountId)}/revoke`,
    request,
  );
  return response.data;
};

export const adminListWallets = async (
  query: WalletListQuery = {},
): Promise<WalletListResponse> => {
  const params = new URLSearchParams();
  if (query.search) params.set("search", query.search);
  if (query.balance) params.set("balance", query.balance);
  if (query.sort) params.set("sort", query.sort);
  if (query.limit) params.set("limit", String(query.limit));
  if (query.cursor) params.set("cursor", query.cursor);
  const qs = params.toString();
  const response = await paymentApi.get<WalletListResponse>(
    qs ? `admin/wallets?${qs}` : "admin/wallets",
  );
  return response.data;
};
